import React, { useState, useEffect } from "react";
import { connect } from "react-redux";
import { getDataFromAPI } from "../../../HandleAPICalls/actions";
import { useNavigate } from "react-router-dom";
import Product_Expiry_Component from "./component";
import { lime } from "@mui/material/colors";

const Product_Expiry_Container = (props) => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [productListData, setProductExpiryData] = useState(null);
  const [searchTerm, setSearchTerm] = useState('');
  const [currentPage, setCurrentPage] = useState(0);
    const limit = 50;
  const [hasMore, setHasMore] = useState(true);

  // Load initial data on component mount
 useEffect(() => {
  // Jab bhi search term change ho, naya API call kare page=0 ke saath
  const delayDebounce = setTimeout(() => {
    loadProducts(0, searchTerm);
  }, 500); // ✅ debounce 500ms

  return () => clearTimeout(delayDebounce);
}, [searchTerm]);


  // Function to load products with page number
 const loadProducts = (pageNumber = 0, searchValue = searchTerm) => {
  setLoading(true);

  const offset = pageNumber * limit; // ✅ fix offset calculation (page * limit)

  props.getDataFromAPI(
    `/dashboard/api/v2/admin/mvs/all?limit=${limit}&offset=${offset}&isActive=1&search=${encodeURIComponent(searchValue)}`,
    "GET",
    undefined,
    (response) => {
      if (response && response.list) {
        if (pageNumber === 0) {
          setProductExpiryData(response);
        } else {
          setProductExpiryData(prevData => ({
            ...prevData,
            list: [...(prevData?.list || []), ...response.list]
          }));
        }
        setHasMore(response.list.length === limit);
      }
      setLoading(false);
      setCurrentPage(pageNumber);
    },
    (error) => {
      setError("Failed to fetch products");
      setLoading(false);
    }
  );
};

  // Load next page of data
  const loadNextPage = () => {
    loadProducts(currentPage + limit);
  };

  // Filter products based on search term
  const filteredProducts = productListData?.list
    ? productListData.list.filter(product =>
        product.variant_name?.toLowerCase().includes(searchTerm.toLowerCase()) ||
        product.variant_id?.toString().includes(searchTerm) ||
        product.id?.toString().includes(searchTerm)
      )
    : [];

  // Format currency
  const formatCurrency = (amount) => {
    if (!amount) return '₹0.00';
    return `₹${parseFloat(amount).toFixed(2)}`;
  };

  return (
<Product_Expiry_Component
  products={productListData?.list || []}
  loading={loading}
  error={error}
  searchTerm={searchTerm}
  setSearchTerm={setSearchTerm}
  currentPage={currentPage}
  navigate={navigate}
  totalItems={productListData?.list?.length || 0}
  hasMore={hasMore}
  onLoadNextPage={() => loadProducts(currentPage + 1, searchTerm)}
  formatCurrency={formatCurrency}
/>

  );
};

function mapStateToProps(props) {
  return {
   props,
  };
}

export default connect(mapStateToProps, {
  getDataFromAPI,
})(Product_Expiry_Container);